/**
 * Извлечение внешнего кольца полигона выделения из состояния DrawingPanel / Draw.
 * DrawController отдаёт `{ geoJSON: Feature }`, не голую Geometry и не `geojson`.
 */

export function extractSelectionPolygonRing(
  drawing: Record<string, unknown> | null | undefined,
): number[][] | null {
  if (!drawing) return null;

  const raw = drawing.geoJSON ?? drawing.geojson;
  if (raw == null) return null;

  try {
    const data = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!data || typeof data !== "object") return null;

    let geom: GeoJSON.Geometry | null = null;
    if (data.type === "Feature") {
      geom = (data as GeoJSON.Feature).geometry;
    } else if (data.type === "FeatureCollection") {
      geom = (data as GeoJSON.FeatureCollection).features?.[0]?.geometry ?? null;
    } else if ("coordinates" in data && "type" in data) {
      geom = data as GeoJSON.Geometry;
    }

    if (!geom) return null;

    if (geom.type === "Polygon" && Array.isArray(geom.coordinates?.[0])) {
      const ring = geom.coordinates[0] as number[][];
      return ring.length >= 4 ? ring : null;
    }

    if (geom.type === "MultiPolygon" && Array.isArray(geom.coordinates?.[0]?.[0])) {
      const ring = geom.coordinates[0][0] as number[][];
      return ring.length >= 4 ? ring : null;
    }

    return null;
  } catch {
    return null;
  }
}

export function hasSelectionPolygon(
  drawing: Record<string, unknown> | null | undefined,
): boolean {
  return extractSelectionPolygonRing(drawing) != null;
}
